import { render, staticRenderFns } from "./homeGroup.vue?vue&type=template&id=f0c30900&scoped=true"
import script from "./homeGroup.vue?vue&type=script&lang=js"
export * from "./homeGroup.vue?vue&type=script&lang=js"
import style0 from "./homeGroup.vue?vue&type=style&index=0&id=f0c30900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c30900",
  null
  
)

export default component.exports